// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 632 ? "component---src-containers-establishment-tsx" : chunkId) + "-" + {"452":"16c451a5397119e72a01","632":"3247e2717c36b22e86cc","896":"c85bc4f15c40caa62050"}[chunkId] + ".js";
};